import React from 'react'
import LoyaltyTierIconWithBackground from 'containers/LoyaltyTierIconWithBackground'
import './index.css'
import capitalizeStringUtil from 'utils/string/capitalize'

export default function ProductCardLoyaltyTierIcon ({
  element,
  tierName,
  isLight
}) {
  logUtil('ProductCardLoyaltyTierIcon').debug('[start]')
  const productLoyaltyTierName = capitalizeStringUtil(
    tierName ||
    element.parentElement?.dataset?.productLoyaltyTierName || ''
  )
  const debugProps = {
    element,
    productLoyaltyTierName
  }
  logUtil('ProductCardLoyaltyTierIcon').debug('debugProps=', debugProps)

  if (!productLoyaltyTierName) {
    logUtil('ProductCardLoyaltyTierIcon').debug('[noop] no tier debugProps=', debugProps)
    return <></>
  }

  return (
    <>
      <LoyaltyTierIconWithBackground
        isLight={isLight}
        tierName={productLoyaltyTierName}
      />
    </>
  )
}
